import { render, staticRenderFns } from "./CompanyDetailToTag.vue?vue&type=template&id=6820e56e&scoped=true"
import script from "./CompanyDetailToTag.vue?vue&type=script&lang=js"
export * from "./CompanyDetailToTag.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailToTag.vue?vue&type=style&index=0&id=6820e56e&prod&lang=css"
import style1 from "./CompanyDetailToTag.vue?vue&type=style&index=1&id=6820e56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820e56e",
  null
  
)

export default component.exports